export const polylines = []
export const setPolyline = newPolyline => polylines.push(newPolyline)
export const clearPolylines = () => polylines.splice(0, polylines.length)



// WEBPACK FOOTER //
// ./app/polylines/index.js